/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import Select from 'react-select';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import VirtualBundleSalesChart from './VirtualBundleSalesLineChart';
import { sortByOptions } from '../../helper';
import { setCurrencyFormat } from '../../../../utils/helpers';

const ShowBySelectedAsins = ({ dir, dataToShowForDatesSelected, 
    title, viewReportButton}) => {
    const [selectedOptions, setSelectedOptions] = useState([])
    const [sortBySelected, setSortBySelected] = useState(sortByOptions[1])    

    const changeFilter = (value) => {
        setSelectedOptions(value)
    };

    const currentDataByCategory = {};
    dataToShowForDatesSelected?.forEach((item) => {

        if (item && currentDataByCategory[`${item?.asin} - ${item?.title}`]) {
            currentDataByCategory[`${item?.asin} - ${item?.title}`]?.push(item);
        } else if (item && (!`${item?.asin} - ${item?.title}` || `${item?.asin} - ${item?.title}` === 'null')) {
            if (currentDataByCategory['N/A']) {
                currentDataByCategory['N/A']?.push(item)
            } else {
                currentDataByCategory['N/A'] = [item]
            }
        } else {
            currentDataByCategory[`${item?.asin} - ${item?.title}`] = [item]
        }
    });

    const currentMonthCat = Object.keys(currentDataByCategory);

    let dataToPlot = [];
    const options = []

    const reduceCallback = (acc, day) => {
        const date = moment(day.reportDate, 'MMM-D-YYYY');
        const dateWithMonthYear = moment(day.reportDate).format('MMM-YYYY-DD');

        if (acc[dateWithMonthYear]) {
            acc?.[dateWithMonthYear]?.push(day)
        } else {
            acc[dateWithMonthYear] = [day]
        }
        return acc
    }

    for (let i = 0; i < currentMonthCat.length; i += 1) {
        const cat = currentMonthCat[i];
        const currentMonth = currentDataByCategory?.[cat] ?? [];

        const currentYearMonthDayWise = currentMonth?.reduce(reduceCallback, {});
        console.log(currentYearMonthDayWise)
        let currentYearMonthMax = 0;

        currentMonth?.forEach((item) => {
            currentYearMonthMax += Number(item.amount)           
        }
        );
        options.push({
            value: cat, label: cat
        })
        dataToPlot.push({
            title: cat,
            currentYearMonthDayWise,
            currentYearMonthMax,
        })
    }

    if (selectedOptions?.length) {
        const selected = selectedOptions?.reduce((acc, item) => {
            acc[item?.value] = item.value
            return acc
        }, {})
        dataToPlot = dataToPlot.filter(item => selected[item.title])
    }

    const sortBy = sortBySelected?.value;

    if (sortBy === 'title') {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
    } else {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy] < b?.[sortBy] ? 1 : -1)
    }

    return (
        <>
            <div className="card__title row align-items-center">
                <h5 className="bold-text col-md-3">{title}</h5>
                <div className="form__form-group mb-0 col-md-7" id='dvChartFilter'>
                    <div className="row justify-content-center align-items-center">
                        <div className="col-6">
                            <span className="form__form-group-label font-weight-bold">
                            Asin or Title
                                </span>
                            <div className="form__form-group-field">
                                <Select
                                    value={selectedOptions}
                                    options={options.sort((a, b) => a.label > b.label ? 1 : -1)}
                                    clearable={false}
                                   // placeholder={`Select ${currentlyShow?.value}`}
                                    className="select_filter"
                                    onChange={changeFilter}
                                    classNamePrefix="react-select"
                                    isMulti

                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <span className="form__form-group-label font-weight-bold">Sort By</span>
                            <div className="form__form-group-field">
                                <Select
                                    value={sortBySelected}
                                    options={sortByOptions}
                                    clearable={false}
                                    placeholder="Sort By"
                                    className="select_filter"
                                    onChange={setSortBySelected}
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-2" id='dvChartView'>
                {viewReportButton?.()}</div>
            </div>
            {dataToPlot?.length ? dataToPlot?.map((category, index) => (
                <Row key={category.title}>
                    <Col sm={4} md={2}><CardText>{category.title} <br />
                        {setCurrencyFormat(Number(category.currentYearMonthMax).toFixed(2), true)}</CardText></Col>
                    <Col sm={8} md={10}>
                        <VirtualBundleSalesChart dir={dir}
                            totalDays={365}
                            currentYearMonthDayWise={category.currentYearMonthDayWise}
                            height={275}
                            showTitle={false}
                            category={category.title}
                           // categorisedBasedOn={categorisedBasedOn}
                            index={index}
                        /></Col>
                </Row>
            )) : 'No data to display'}
        </>

    )
}

ShowBySelectedAsins.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToShowForDatesSelected: PropTypes.array.isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,

};

ShowBySelectedAsins.defaultProps = {
    title: 'Virtual Bundle Sales',
}

export default ShowBySelectedAsins;
